import { ModuleWithProviders, NgModule } from '@angular/core';

import { ReportPeriodConfiguration } from './configuration';
import { ReportPeriodService } from './report-period.service';

@NgModule()
export class ReportPeriodModule {
    static forRoot(): ModuleWithProviders<ReportPeriodModule> {
        return {
            ngModule: ReportPeriodModule,
            providers: [ReportPeriodService, ReportPeriodConfiguration],
        };
    }
}
